import React, {useEffect} from 'react';
import {useEnvironment} from '@wix/yoshi-flow-editor';
import {Header} from '../Header/Header';
import {AsideSummary} from '../Summary/AsideSummary/AsideSummary';
import {FastFlow} from '../FastFlow/FastFlow';
import {Footer} from '../Footer/Footer';
import {useControllerProps} from '../Widget/ControllerContext';
import {TPAComponentsProvider} from '@wix/wix-ui-tpa/cssVars';
import {FullFlow} from '../FullFlow/FullFlow';
import {SummaryLocation} from '../../../types/checkoutApp.types';
import {getDirValue} from '../../../domain/utils/getDirValue';
import {Layout} from '../../../common/components/Layout/Layout';
import {pageTheme} from '../../../common/components/WithThemeOverride/pageTheme';
import {CheckoutErrorState} from '../CheckoutErrorState/CheckoutErrorState';

export enum CheckoutAppDataHook {
  root = 'CheckoutAppDataHook.root',
  footer = 'CheckoutAppDataHook.footer',
  header = 'CheckoutAppDataHook.header',
  summary = 'CheckoutAppDataHook.summary',
}

const CheckoutApp = () => {
  const {failedToFetch, isLoading, checkoutStore, isOneColumnView, checkoutSettingsStore} = useControllerProps();
  const {isRTL} = useEnvironment();
  const hasPremiumError = !isLoading && !checkoutSettingsStore?.isPremium && !checkoutSettingsStore?.isOwner;

  const hasError = failedToFetch || hasPremiumError;

  useEffect(
    () => {
      if (isLoading) {
        return;
      }

      checkoutStore.checkoutPageFinishLoading({hasPremiumError});
    },
    /* eslint-disable react-hooks/exhaustive-deps*/ [isLoading]
  );

  return (
    <div style={pageTheme}>
      <TPAComponentsProvider value={{rtl: isRTL}}>
        <Layout
          dataHook={CheckoutAppDataHook.root}
          isLoading={isLoading}
          showErrorState={hasError}
          isOneColumnView={isOneColumnView}
          dir={getDirValue(isRTL)}
          Header={() => <Header dataHook={CheckoutAppDataHook.header} />}
          Aside={() => <AsideSummary dataHook={CheckoutAppDataHook.summary} location={SummaryLocation.checkoutApp} />}
          ErrorState={() => <CheckoutErrorState hasPremiumError={hasPremiumError} />}
          Footer={() => <Footer dataHook={CheckoutAppDataHook.footer} />}>
          {checkoutStore?.isFastFlow ? <FastFlow /> : <FullFlow />}
        </Layout>
      </TPAComponentsProvider>
    </div>
  );
};

// eslint-disable-next-line import/no-default-export
export default CheckoutApp;
